import axios from "@/plugins/axios";
import utils from "@/stores/utils";

const state = {
    search: null,
    searching: false,
    searching_errors: false,
    results: [],
    entity: null,
    usemail: false,
    email: null,
    message: null,
    selected_catalog_ids: [],
    catalogs: [],
    catalogs_loading: false,
    inviting: false,
};

const mutations = {
    updateSearch(state, search) {
        state.search = search;
    },
    updateSearching(state, searching) {
        state.searching = searching;
    },
    updateSearchingErrors(state, errors) {
        state.searching = false;
        state.searching_errors = errors;
    },
    updateResults(state, results) {
        state.results = results;
    },
    updateEntity(state, entity) {
        state.entity = entity;
    },
    updateUsemail(state, usemail) {
        state.usemail = usemail;
    },
    updateEmail(state, email) {
        state.email = email;
    },
    updateMessage(state, message) {
        state.message = message;
    },
    updateSelectedCatalogIds(state, ids) {
        state.selected_catalog_ids = ids;
    },
    updateCatalogs(state, catalogs) {
        state.catalogs = catalogs;
    },
    updateCatalogsLoading(state, loading) {
        state.catalogs_loading = loading;
    },
    updateInviting(state, inviting) {
        state.inviting = inviting;
    },
};

const actions = {
    async searchAgents({ commit, state }) {
        if (!state.search) {
            commit("updateResults", []);
            return;
        }
        commit("updateSearching", true);
        try {
            const response = await axios.get("/api/searchentities/", {
                params: { search: state.search, agents_only: true },
            });
            commit("updateResults", response.data);
            commit("updateSearching", false);
            return response;
        } catch (xhr_error) {
            const errors = utils.handleError(xhr_error);
            commit("updateSearchingErrors", errors.details);
            throw errors;
        }
    },

    async fetchOwnedCatalogs({ commit }) {
        commit("updateCatalogsLoading", true);
        try {
            const response = await axios.get("/api/catalogs/", {
                params: {
                    type: "sell",
                    owned: true,
                    archived: false,
                    limit: 1000,
                },
            });
            commit("updateCatalogs", response.data.results || []);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateCatalogsLoading", false);
        }
    },

    async inviteAgent({ commit, state }) {
        commit("updateInviting", true);
        try {
            const response = await axios.post("/api/invitations/", {
                email_or_safetee_id: state.entity?.safetee_id || state.email,
                invite_as_commercial_agent: true,
                catalogs: state.selected_catalog_ids,
                message: state.message || undefined,
            });
            return response.data;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateInviting", false);
        }
    },

    async init({ commit, dispatch }) {
        commit("updateSearch", null);
        commit("updateEmail", null);
        commit("updateUsemail", false);
        commit("updateResults", []);
        commit("updateEntity", null);
        commit("updateMessage", null);
        commit("updateSelectedCatalogIds", []);
        await dispatch("fetchOwnedCatalogs");
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
